import {useCallback, useEffect, useState} from 'react'

const useTokenTicket = () => {
  const [tokenTicket, setToken] = useState<string>(() => localStorage.getItem('tokenTicket'))

  const deleteToken = useCallback(() => {
    localStorage.removeItem('tokenTicket')
    setToken(null) // re-renderización en la misma pestaña
    // podría enviar un postMessage para una acción centralizada
  }, [])

  // para sincronizar con otras pestañas
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'tokenTicket') {
        setToken(e.newValue)
        // para lógica en otras pestañas
        // si se elimina:
        if (e.newValue === null) {
          console.log('tokenTicket eliminado por otra pestaña.')
        }
      }
    }
    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])
  
  return {tokenTicket, deleteToken}
}

export default useTokenTicket